import { realBricksApi } from '../../utils/axiosInterceptors';

export const getCitiesData = async (data, { rejectWithValue }) => {
  const { page, perPage, isSecondary, searchText, onFail = () => {} } = data;
  try {
    const response = await realBricksApi.get(
      `/api/v1/cities?isSecondary=${isSecondary}&page=${page}&limit=${100}${searchText && searchText !== '' ? `&search=${searchText}` : ''}`
    );
    return response.data;
  } catch (err) {
    onFail();
    return rejectWithValue(err?.response?.data?.message);
  }
};

export const getPropertTypeData = async (data = {}, { rejectWithValue = () => {} } = {}) => {
  const { isSecondary, isFavorite, onFail = () => {} } = data;
  try {
    let url = `/api/v1/property-type`;
    if ('isSecondary' in data) {
      url = `${url}?isSecondary=${isSecondary}`;
    }
    if ('isFavorite' in data) {
      if (url.includes('?')) {
        url = `${url}&isFavorite=${isFavorite}`;
      } else {
        url = `${url}?isFavorite=${isFavorite}`;
      }
    }
    const response = await realBricksApi.get(url);
    return response.data;
  } catch (err) {
    onFail();
    return rejectWithValue(err?.response?.data?.message);
  }
};

export const getLeverageData = async (data, { rejectWithValue }) => {
  const { isSecondary, onFail = () => {} } = data;
  try {
    const response = await realBricksApi.get(`/api/v1/properties/leverage-wise-count?isSecondary=${isSecondary}`);
    return response.data;
  } catch (err) {
    onFail();
    return rejectWithValue(err?.response?.data?.message);
  }
};

export const getSearchHistoryData = async (data = {}, { rejectWithValue = () => {} } = {}) => {
  const { onFail = () => {} } = data;
  try {
    const response = await realBricksApi.get(`/api/v1/search-history?page=1&limit=5&sortType=DESC&sortField=id`);
    return response.data;
  } catch (err) {
    onFail();
    return rejectWithValue(err?.response?.data?.message);
  }
};

export const postSearchHistory = async (data = {}, { rejectWithValue = () => {} } = {}) => {
  const { onFail = () => {} } = data;
  try {
    const response = await realBricksApi.post(`/api/v1/search-history`, data);
    return response.data;
  } catch (err) {
    onFail();
    return rejectWithValue(err?.response?.data?.message);
  }
};

export const getMarketPlaceSearch = async (data, { rejectWithValue = () => {} } = {}) => {
  const { page = 0, perPage = 0, isSecondary, search, onFail = () => {} } = data;
  try {
    const response = await realBricksApi.get(
      `/api/v1/properties/marketplace-search?${'isSecondary' in data ? `isSecondary=${isSecondary}` : ''}${page ? `&page=${page}` : ''}${
        perPage ? `&limit=${perPage}` : ''
      }${search && search !== '' ? `&search=${search}` : ''}`
    );
    return response.data;
  } catch (err) {
    onFail();
    return rejectWithValue(err?.response?.data?.message);
  }
};

export const getAllPropertyTypes = async (cancelToken) => {
  return realBricksApi.get(`/api/v1/property-type`, {
    cancelToken,
    params: {
      page: 1,
      limit: 200,
    },
  });
};
